import { toJpeg } from 'html-to-image'
import type { TesterShot } from '@/modules/test-module-chitiet/tester/shotStore'

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms))

/** Chụp đúng vùng tester đang nhìn (bỏ banner test nổi). */
export async function captureNode(node: HTMLElement, label: string): Promise<TesterShot> {
  node.scrollIntoView({ block: 'nearest', inline: 'nearest' })
  await sleep(180)
  const rect = node.getBoundingClientRect()
  const width = Math.max(1, Math.ceil(rect.width))
  const height = Math.max(1, Math.ceil(rect.height))
  try {
    const dataUrl = await toJpeg(node, {
      quality: 0.72,
      pixelRatio: 1,
      backgroundColor: '#ffffff',
      skipFonts: true,
      cacheBust: true,
      width,
      height,
      canvasWidth: width,
      canvasHeight: height,
      filter: (domNode) => {
        if (!(domNode instanceof HTMLElement)) return true
        return domNode.dataset.uiTestOverlay !== 'true'
      },
    })
    return { id: label, label, dataUrl }
  } catch (e) {
    return {
      id: label,
      label,
      dataUrl: '',
      error: (e as { message?: string })?.message || 'Không chụp được ảnh',
    }
  }
}
